<oui-select
  label="Modes de paiement"
  [control]="control"
  [options]="options"
  class="width-100pc"
  [multiple]="true"></oui-select>
